// extracted by mini-css-extract-plugin
export default {"otpbox":"SignIn_otpbox__Uz6nA","otpboxdisplay":"SignIn_otpboxdisplay__c-RaE"};